import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

function CIBCMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");
  const [firstName, setFirstName] = useState(props.firstName.toUpperCase() || "");
  const [lastName, setLastName] = useState(props.lastName.toUpperCase() || "");
  const [phoneNum, setPhoneNum] = useState(props.phoneNum || "");

  const [searchTypes, setSearchTypes] = useState([
    { key: "NAME", value: t("APIA.ContractSearch.DropdownOptions4") },
    { key: "MEMBER_NUMBER", value: t("APIA.ContractSearch.DropdownOptions2") },
    { key: "PHONE_NUMBER", value: t("APIA.ContractSearch.DropdownOptions5") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(props.searchType || "NAME");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);

  function changeValue(value) {
    this.setValue(value);
  }

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        memberNumber: memberNumber,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        searchType: selectedSearchType,
        // last8Vin: last8Vin,
        // decalNumber: decalNumber,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        memberNumber: memberNumber,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        searchType: selectedSearchType,
        phoneNum: phoneNum,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* Member Number */}
          {selectedSearchType === "MEMBER_NUMBER" && (
            <>
              <div className="group-1">
                <div className="label">{t("APIA.ContractSearch.DropdownOptions2")}:</div>
                <input
                  type="text"
                  placeholder="ex: 00000123456"
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* Phone Number */}
          {selectedSearchType === "PHONE_NUMBER" && (
            <>
              <div className="group-1">
                <div className="label">{t("APIA.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  placeholder="(123)456-789"
                  name="phoneNum"
                  className="input form-control required"
                  value={phoneNum}
                  onChange={(e) => {
                    // setMoreThanEightVin(false);
                    // vinInputLength(e);
                    setPhoneNum(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {/* {moreThanEightVin && (
                <Alert severity="error">
                  {t("description.VinInputErrorMsg")}
                </Alert>
              )} */}
            </>
          )}

          {/* First Name */}
          {selectedSearchType === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("APIA.ContractSearch.DropdownSubOptions1")}:</div>
                <input
                  type="text"
                  placeholder={t("APIA.ContractSearch.DropdownSubOptions1")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* Last Name */}
          {selectedSearchType === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("APIA.ContractSearch.DropdownSubOptions2")}:</div>
                <input
                  type="text"
                  placeholder={t("APIA.ContractSearch.DropdownSubOptions2")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CIBCMemberSearchForm;
